import { useCallback, useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import AvatarViewerLoading from "./AvatarViewerLoading";
import { GetBucket, GetSMARTCheckDomain } from "../../lib/common";
import MPageHeader from "../commons/MPageHeader";
import { useNavigate } from "react-router-dom";
import { AvatarConstant } from "../../redux/reducers";
import i18next from "i18next";
import _ from "lodash";

const USE_BACK = false;
const AvatarViewer = ({ avatarItem, callbackSetDefault }) => {
  const [visible, setVisible] = useState(false);
  const [iframeSrc, setIframeSrc] = useState("");
  const [iRef, setIRef] = useState(null);
  const [exMessage, setExMessage] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intervalRef = useRef({
    interval: null,
    startTime: null,
    networkLimitTime: 1000 * 20,
  });
  const [safePadding, setSafePadding] = useState(0);

  useEffect(() => {
    const { s3keypath, region } = (avatarItem || {});
    if (!s3keypath || !region) {
      setIframeSrc("");
      return;
    }
    const _domain = GetSMARTCheckDomain();
    const paramsArr = [
      `keypath=${s3keypath}`,
      `region=${region}`,
      `bucket=${GetBucket(region)}`,
    ];
    const _url = `${_domain}/virtualsmile?${paramsArr.join("&")}`
    setIframeSrc(_url);
  }, [avatarItem]);

  useEffect(() => {
    if (!iRef) {
      return;
    }
    const cb = (msg) => {
      if (msg?.data?.from === "viewer") {
        const loadStatus = msg?.data?.data?.loading;
        if (loadStatus === "done") {
          setVisible(true);
        }
      }
    };
    window.addEventListener("message", cb, false);
    return () => {
      cb && window.removeEventListener("message", cb)
    }
  }, [iRef]);

  const callbackClickLogo = useCallback(() => {
    if (USE_BACK) {
      dispatch({ type: AvatarConstant.SET_PASSWORD, value: "" });
      navigate("/");
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    let iv;
    if (!intervalRef.current?.interval) {
      setExMessage("");
      iv = intervalRef.current.interval = setInterval(async () => {
        const now = new Date().getTime();
        if (!intervalRef.current.startTime) {
          intervalRef.current.startTime = now;
        }
        if (intervalRef.current.startTime && now - intervalRef.current.startTime > intervalRef.current.networkLimitTime) {
          setExMessage(i18next.t("Data uploads are delayed due to poor network connectivity"));
          clearInterval(iv);
        }
      }, 1000 * 5);
    }
    return () => {
      if (iv) {
        clearInterval(iv);
      }
    }
  }, []);

  useEffect(() => {
    if (visible && intervalRef.current.interval) {
      clearInterval(intervalRef.current.interval);
    }
  }, [visible]);

  useEffect(() => {
    const cb = () => {
      try {
        const gap = document.documentElement.scrollHeight - window.innerHeight;
        setSafePadding(gap);  
      } catch (error) {
        setSafePadding(0);
      }
    };
    const resizeHandler = _.throttle(cb, 200);
    cb();
    window.visualViewport.addEventListener("resize", resizeHandler);
    return () => {
      window.visualViewport.removeEventListener("resize", resizeHandler);
    }
  }, [visible]);

  return <>
    <div className="flex-fill w-100 h-100">
      {iframeSrc && <>
        <div className="d-flex flex-column w-100 h-100" style={{ 
          backgroundColor: "#131736",
          opacity: visible ? 1 : 0,
          zIndex: visible ? 2 : 1,
          transition: "all 0.5s",
        }}>
          <MPageHeader isWhite={true} callbackClickLogo={callbackClickLogo} />
          <div className="flex-fill w-100 position-relative">
            <iframe
              ref={setIRef}
              title="SMARTCheck Viewer"
              src={iframeSrc}
              style={{
                position: 'absolute',
                inset: 0,
                width: "100%",
                height: "100%",
                maxHeight: `calc(100% - ${safePadding}px)`,
              }}
            />
          </div>
        </div>
      </>}
      <div
        className="position-absolute"
        style={{
          inset: 0,
          opacity: visible ? 0 : 1,
          zIndex: visible ? -1 : 2,
          transition: "all 0.5s",
        }}
      >
        <AvatarViewerLoading exMessage={exMessage} />
      </div>
    </div>
  </>
};

const mapState = (state) => {
  const auth = state.AuthReducer.user;
  const token = state.AuthReducer.token;
  const avatarItem = state.AvatarReducer.item;
  return { auth, token, avatarItem };
};
const mapDispatch = (dispatch) => ({
  // RefreshAvatar: () => dispatch(AvatarAction.RefreshAvatar()),
});

export default connect(mapState, mapDispatch)(AvatarViewer);